import React, { useEffect, useState } from "react";

import { fetchTrainingInvoices } from "services/dashboard.services";
import { NoResultsSection } from "reusableComponents";
import { useTranslation } from "react-i18next";
import LoadingPage from "views/LoadingPage";
import { useSelector } from "react-redux";
import { eyeIcon } from "assets/icons";
import { useModal } from "context";
import { DownloadIcon } from "assets/icons/svgComponents";

import styles from "./styles.module.scss";
import { useNavigate } from "react-router";

const TrainingInvoices = () => {
  const { t } = useTranslation("global");
  const { openModal } = useModal();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.token);
  // const fakeInvoices = [
  //   {
  //     id: 1,
  //     reservation_number: "RES12345",
  //     dates: "2025-01-01 to 2025-01-05",
  //     space_name: "Conference Room A",
  //     amount: "250",
  //     url: "/invoice/1",
  //   },
  //   {
  //     id: 2,
  //     reservation_number: "RES67890",
  //     dates: "2025-02-10 to 2025-02-12",
  //     space_name: "Event Hall B",
  //     amount: "500",
  //     url: "/invoice/2",
  //   },
  //   {
  //     id: 3,
  //     reservation_number: "RES54321",
  //     dates: "2025-03-15 to 2025-03-16",
  //     space_name: "Coworking Space C",
  //     amount: "100",
  //     url: "/invoice/3",
  //   },
  //   {
  //     id: 4,
  //     reservation_number: "RES98765",
  //     dates: "2025-04-20 to 2025-04-25",
  //     space_name: "Meeting Room D",
  //     amount: "400",
  //     url: "/invoice/4",
  //   },
  // ];

  useEffect(() => {
    const fetchInvoices = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchTrainingInvoices(token);
        setInvoices(data.data || []); // Handle empty data gracefully
      } catch (err) {
        setError(err.message || t("dashboard.messages.fetchError"));
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, [token, t]);

  const handleOpenModal = (subject, bodyContent) => {
    openModal({
      content: <p dangerouslySetInnerHTML={{ __html: bodyContent }} />,
      title: subject,
      type: "default",
      autoClose: false,
      closeDelay: 3000,
      size: "medium", // Assuming `true` here corresponds to "medium" size
    });
    
  };

  if (error)
    return (
      <div className={styles.error}>
        <p>{error}</p>
      </div>
    );

  return (
    <div
      className={`${styles.bookingInvoicesPage} ${
        loading ? styles.loading : ""
      }`}
    >
      {" "}
      <h2 className={styles.title}>{t("dashboard.invoice.titleSeeker")}</h2>
      {invoices.length > 0 ? (
        <div className={styles.invoicesTable}>
          <div className={styles.tableHeader}>
            <h3 className={styles.tableHeaderTitle}>
              {t("dashboard.invoice.table.reference")}
            </h3>
            <p className={styles.tableHeaderTitle}>
              {t("dashboard.invoice.table.dates")}
            </p>
            <p className={styles.tableHeaderTitle}>
              {" "}
              {t("dashboard.invoice.table.espace")}
            </p>
            <p className={styles.tableHeaderTitle}>
              {t("dashboard.invoice.table.amount_ht")}
            </p>

            <span></span>
          </div>
          {invoices.map((invoice) => (
            <div key={invoice.id} className={styles.tableItem}>
              <h3
                className={`${styles.tableItemText} ${styles.reservationNumber}`}
              >
                {invoice.reservation_number}
              </h3>
              <p className={`${styles.tableItemText} ${styles.invoiceDates}`}>
                {invoice.dates}
              </p>
              <p className={`${styles.tableItemText} ${styles.spaceName}`}>
                {invoice.space_name}
              </p>
              <p className={`${styles.tableItemText} ${styles.invoiceAmount}`}>
                {invoice.amount}€
              </p>

              <button
                className={styles.eyeIcon}
                onClick={() => window.open(invoice.url, '_blank')}
                aria-label={`View message: ${invoice.subject}`}
              >
                <DownloadIcon width={"24px"} height={"24px"} className={styles.downloadIcon}/>
              </button>
            </div>
          ))}
        </div>
      ) : (
        <NoResultsSection
          title={t("dashboard.invoice.noResultTitle")}
          text={t("dashboard.invoice.noResultText")}
        />
      )}
    </div>
  );
};

export default TrainingInvoices;
